/* FIXME: This component was modified to look as sunrise but needs to be migrated to use the new Sunrise components */
import type { ComponentProps } from 'react';
import type React from 'react';

import { Radio } from '@change-corgi/design-system-legacy/components/forms';
import { Box } from '@change-corgi/design-system-legacy/layout';

const radioCardStyles = {
	'&:hover': {
		boxShadow: '0px 6px 12px 0px rgba(0, 0, 0, 0.25)',
		borderRadius: '0.5rem',
	},
	'& > label': {
		borderRadius: '0.5rem',
		borderWidth: 1,
		borderColor: 'var(--color-fill-overlay)',
		borderStyle: 'solid',
		backgroundColor: 'var(--color-fill-overlay)',
		display: 'flex',
		flexDirection: 'column-reverse',
		alignItems: 'center',
		'& > input[type="radio"]': {
			marginTop: 6,
			marginBottom: 18,
			marginRight: 0,
		},
	},
	'& > label:focus-within, & > label[data-selected="true"]': {
		outlineRadius: '0.5rem',
		outlineWidth: 3,
		outlineStyle: 'solid',
		outlineColor: '#4771FF',
	},
	'& > label > input[type="radio"]:focus': {
		outline: 'none',
	},
	'& > label > input[type="radio"]:checked': {
		accentColor: '#4771FF',
	},
	'& > label > .boolean-input-label': {
		overflow: 'hidden',
		borderTopRightRadius: '0.5rem',
		borderTopLeftRadius: '0.5rem',
		backgroundColor: 'var(--color-fill-inverse-strong)',
	},
} as const;

export const RadioCard: React.FC<
	ComponentProps<typeof Radio> & { className?: string } & { ref?: React.RefObject<HTMLInputElement> }
> = ({ className, ref, ...rest }) => {
	return (
		<Box className={className} sx={{ ...radioCardStyles }}>
			<Radio {...rest} ref={ref} />
		</Box>
	);
};
